export function getClientInfo() {
  const desktop = typeof window !== "undefined" ? window.wunityDesktop : null;

  if (desktop && desktop.isElectron) {
    return {
      runtime: "electron",
      platform: desktop.platform,
      capabilities: {
        canBeControlled: Boolean(desktop.canBeControlled),
      },
    };
  }

  return {
    runtime: "web",
    platform: "web",
    capabilities: { canBeControlled: false },
  };
}

export const REMOTE_CONTROL_ERRORS = {
  not_authorized: "remoteControl.error.notAuthorized",
  host_not_controllable: "remoteControl.error.hostNotControllable",
  no_screen: "remoteControl.error.noScreen",
  busy: "remoteControl.error.busy",
  cannot_control_self: "remoteControl.error.cannotControlSelf",
  session_not_found: "remoteControl.error.sessionNotFound",
  invalid_state: "remoteControl.error.invalidState",
};
